import type { AppId } from 'constants/known-apps';
import type { ImportEntity } from 'redux/modules/apps.types';
import type { Features } from './account';

export enum ScopeTypes {
  user = 'user',
  account = 'account',
}

export interface App {
  id: AppId;
  app_id: number;
  authorize_url: string;
  authorize_full_url?: string;
  category: string;
  can_connect: boolean;
  display_name: string;
  feature_requirements: Array<keyof Features>;
  provider: string;
  platforms: Array<string>;
  description: string;
  summary: string;
  integrated: boolean;
  connected_integrations_count: number;
  disconnected_integrations_count: number;
  last_imported_at: string | null;
  first_created_at: string | null;
  import_support: Array<string> | null;
  logo_path: string;
  logo_url: string;
  scope: ScopeTypes;
  connected_apps_url: string;
  /** Indicates a premium app, available to account.features.premium_integrations */
  premium: boolean;
  unlimited_plus: boolean;
  html: {
    summary: string;
    uninstall: string;
  } | null;
  support_url: string | null;
  is_importing: boolean;
}

export interface AppAccount<O = unknown> {
  id: number;
  name: string;
  email: string;
  first_imported_at: string | null;
  last_imported_at: string | null;
  last_exported_at: string | null;
  created_at: string;
  updated_at: string;
  objects: boolean;
  objects_type?: null | 'calendars' | 'workspaces';
  disconnected: boolean;
  disconnected_reason: string | null;
  active: boolean;
  manage: boolean;
  options: O | null;
  parent?: {
    id?: number | null;
    name?: string | null;
    email?: string | null;
  } | null;
  state: 'active' | 'inactive' | 'in_progress' | 'failed';
  /** OAuth resource identifier (e.g., Google Sheets spreadsheet ID). Only populated for export integrations. */
  resource_id?: string | null;
}

export interface AppSubscription {
  etag: string;
  integrated: boolean;
  name: string;
  object_id: string;
  updated_at: string;
}

export interface AppOptionsResponse {
  id: number;
  status: string;
  updated_at: string;
  finished_at: string | null;
  details: {
    workspaces: Array<{ id: number; name: string }>;
    boards: Array<{ id: number; name: string }>;
    spaces: Array<{ id: number; name: string }>;
    parents: Array<{ id: number; name: string }>;
    projects: Array<{ id: number; name: string }>;
  };
}

export interface AppEntityImportRequest {
  job_id: number;
  account_app: {
    parent_ids: Array<ImportEntity['id']>;
  };
  parent_source: 'workspace' | 'parent' | 'board' | 'project' | 'space';
}
